import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

import { getAppointmentsPsychological } from "../../api/appointments";

import { IAppointment } from "../../interface/IAppointment";

export const TerminhistoriePage = () => {
  const [loading, setLoading] = useState(false);
  const [appointmentData, setAppointmentData] = useState<IAppointment[]>();

  const { patient } = useParams();

  useEffect(() => {
    const getAppointments = async () => {
      try {
        setLoading(true);
        const response = await getAppointmentsPsychological(patient);

        setAppointmentData(response.data);
      } catch (error: any) {
        console.error("Error fetching appointments:", error.message);
      } finally {
        setLoading(false);
      }
    };
    getAppointments();
  }, [patient]);

  return (
    <Grid container mt={2}>
      {loading ? (
        <Grid
          container
          sx={{
            height: "500px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress size={100} />
        </Grid>
      ) : (
        <Box>
          {appointmentData && appointmentData.length > 0 ? (
            <>
              <Grid item xs={12} sm={12} mt={3}>
                <Typography variant="h5" component="h5" fontWeight={600} mb={3}>
                  Termine „Dating-Geschichte“
                </Typography>
              </Grid>
              {appointmentData?.map((appointment, index) => (
                <Grid container item xs={12} sm={7} key={index} mb={4}>
                  <Grid item xs={12} sm={3}>
                    <Typography variant="subtitle2">Terminart:</Typography>
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {appointment.type}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Typography variant="subtitle2">Datum:</Typography>
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {appointment.date}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Typography variant="subtitle2">Uhrzeit:</Typography>
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {appointment.time} hrs
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Typography variant="subtitle2">Zustand:</Typography>
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    {appointment.canceled === true ? (
                      <Typography
                        variant="subtitle2"
                        fontWeight={600}
                        sx={{ color: "red" }}
                      >
                        Termin Abgesagt
                      </Typography>
                    ) : new Date(appointment.datetime) > new Date() ? (
                      <Typography
                        variant="subtitle2"
                        fontWeight={600}
                        sx={{ color: "green" }}
                      >
                        Aktiver Termin
                      </Typography>
                    ) : (
                      <Typography
                        variant="subtitle2"
                        fontWeight={600}
                        sx={{ color: "green" }}
                      >
                        Termin Beendet
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Typography variant="subtitle2">Termintyp:</Typography>
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <Typography variant="subtitle2" fontWeight={600}>
                      {appointment.type}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </>
          ) : (
            <Grid item xs={12} sm={12} mb={15}>
              <Typography variant="h5" component="h5" fontWeight={600} mb={1}>
                Allgemeine Daten
              </Typography>
              <Typography color="red">
                Keine relevanten Informationen verfügbar
              </Typography>
            </Grid>
          )}
        </Box>
      )}
    </Grid>
  );
};
